import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConsultationServicesComponent } from './consultation-services.component';
const routes: Routes = [ 
  {
  path: '',
  component: ConsultationServicesComponent,
}]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConsultationServicesRoutingModule { }
